/* eslint-disable camelcase */
import { readCookieRaw } from '../utils/cookies'
import uuidv4 from '../utils/guid'

if (
  window.__BRAND__ === 'uswitch' &&
  window.location.pathname.replace(/\/$/, '') === '/business-insurance/pm-1'
) {
  const CTAs = Array.from(document.querySelectorAll('.button_atom')).filter(
    (b) => b.innerText.includes('Get') && b.innerText.includes('quote'),
  )
  const getLink = (element) => {
    if (element) {
      if (element.tagName === 'A') {
        return element.href
      } else if (element.tagName === 'FORM') {
        return element.getAttribute('action')
      } else return getLink(element.parentElement)
    }
    return null
  }

  const randomId = uuidv4()
  const widgetParams = {
    cobrand: 'uswitch',
    utm_source: 'uswitch',
    utm_campaign: 'partner_uswitch',
    p_custid: readCookieRaw('uscd'),
    puid: randomId,
  }
  const body = document.getElementsByTagName('body')[0]
  const hiddenElementForParams = document.createElement('div')
  hiddenElementForParams.style.display = 'none'

  const qbParams = new URLSearchParams(widgetParams).toString()
  hiddenElementForParams.classList.add('qb-launcher')
  hiddenElementForParams.setAttribute('data-qb-params', qbParams)

  body.appendChild(hiddenElementForParams)

  CTAs.forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault()
      window.QB('show')
      const link = getLink(b)
      if (link) {
        const clickoutLink = new URL(link)
        clickoutLink.searchParams.append('c', randomId)

        fetch(clickoutLink)
      } else {
        // eslint-disable-next-line no-console
        console.log('Clickout link not found')
      }
    })
  })

  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://online-quote.gosuperscript.com/launcher.js'

  head.appendChild(script)
}
